import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-agree-data-collection',
  templateUrl: './agree-data-collection.component.html',
  styleUrls: ['./agree-data-collection.component.scss'],
})
export class AgreeDataCollectionComponent implements OnInit {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<AgreeDataCollectionComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { text: string; buttonText: string }
  ) {}
  ngOnInit(): void {
    this.bottomSheetRef.backdropClick().subscribe((click) => {
    });
  }

  close(agreed) {
    this.bottomSheetRef.dismiss(agreed);
  }
}
